module.exports = __webpack_public_path__ + "assets/img/help_pagination01-2.0e14b97b.svg";